import React, { useRef } from 'react';
import './app.scss';
import StepRouter from './step-router';

/**
 * App to display the redesigned gated flow.
 * - https://www.figma.com/file/uD4aOK2m0pHHU5n112cQ0G/Owner-Growth%3A-PM-Page?node-id=552%3A4699
 * - https://vacasait.atlassian.net/browse/RC-1
 */
export const GatedEstimator2021App: React.FC = () => {
    const scrollTarget = useRef<HTMLDivElement>(null);
    return (
        <div className="gated-app">
            <StepRouter scrollTarget={scrollTarget} />
            <div ref={scrollTarget} />
        </div>
    );
};
